(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea7a1"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea7a1"] = parcelRequire;
}
parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

var $62c73d80f4c5ce68$exports = {};

(parcelRequire("iE7OH")).register(JSON.parse('{"eEdY6":"index.effa11fc.js","9lG97":"worker.066485bf.js","aTlLu":"worker.18fe396d.js","4noOu":"zappar-cv.315eebda.wasm","kNvxM":"face_mesh_face_model.9f3b859a.zbin","98I7t":"face_mesh_full_head_simplified_model.caf9de0a.zbin","I7W5Q":"face_tracking_model.624095d1.zbin","hq0mX":"macula.768fcc00.png","femmd":"cataracts.7b0a9104.png","bbV0l":"bluenoise.bdbe3726.png","5Swzl":"camouflage-1.d85fb5f3.png","kD5ss":"camouflage-2.86017a97.png","99VnP":"camouflage-3.8b41ea77.png","f3Yyz":"camouflage-4.adf313fc.png","anoQy":"camouflage-5.3f24d933.png","3aUHn":"tunnel-1.a917dd34.png","wadZo":"tunnel-2.d74b03aa.png","9vMEj":"tunnel-3.12655810.png","7nwIx":"tunnel-4.791a15c4.png","6ob2k":"tunnel-5.9fb7f8ec.png","3nQMt":"glaucoma-1.1baf327f.png","goKD6":"glaucoma-2.ccd4b3ce.png","kzspj":"glaucoma-3.06451552.png","c706f":"glaucoma-4.6ed5cde2.png","jMzmp":"glaucoma-5.f7fea49e.png","3ZZKc":"index.a95ebe3e.css"}'));

})();
//# sourceMappingURL=index.4bc55557.js.map
